import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Spinner } from "react-bootstrap";
import { removeIaImage } from "../../REDUX/actions/ia";

/** Vignettes des images en attente d'envoi. */
const IaImagePreview = () => {
  const dispatch = useDispatch();
  const { pendingImages } = useSelector((state) => state.iaReducer);

  if (!pendingImages.length) return null;

  return (
    <div className="d-flex flex-wrap gap-2 px-3 pb-2">
      {pendingImages.map((image) => (
        <div key={image.localId} className="iaPendingImage br5">
          <img src={image.preview} alt={image.name} className="br5" />

          {image.uploading && (
            <div className="iaPendingImageOverlay alignC br5">
              <Spinner animation="border" variant="light" size="sm" />
            </div>
          )}

          <button
            type="button"
            className="iaPendingImageRemove border-0"
            onClick={() => dispatch(removeIaImage(image.localId))}
          >
            <i className="bi bi-x" />
          </button>
        </div>
      ))}
    </div>
  );
};

export default IaImagePreview;
